import Toastr from "../../../itrust_common/components/Toastr";

const organisationName = window.location.host.split(".")[0];
export const BASEURL = 'https://support.itrust.io/'

const getData = () => {
  const email = localStorage.getItem("User-email");
  const firstname = localStorage.getItem("User-firstname");
  const lastname = localStorage.getItem("User-lastname");
  return { email, firstname, lastname };
}

export async function getAllTickets() {
  const { email, firstname, lastname } = getData();
  const url = `${BASEURL}api/v1/tickets`;
  const res = await fetch(url, {
    method: "GET",
    headers: {
      "user-email": email,
      "user-firstname": firstname,
      "user-lastname": lastname,
      "user-type": "Customer",
      "user-org": organisationName,
    },
  });
  const data = await res.json();
  if (!res.ok) {
    Toastr.handleShow(false, "Failed to load tickets");
  }
  return data;
}
export async function getTickets(id) {
  const { email, firstname, lastname } = getData();
  const url = `${BASEURL}api/v1/tickets/${id}`;
  const res = await fetch(url, {
    method: "GET",
    headers: {
      "user-email": email,
      "user-firstname": firstname,
      "user-lastname": lastname,
      "user-type": "Customer",
      "user-org": organisationName,
    },
  });
  const data = await res.json();
  if (!res.ok) {
    Toastr.handleShow(false, "Failed to load ticket");
  }
  return data;
}

export async function getArticles(id) {
  const { email } = getData();
  const url = `${BASEURL}api/v1/ticket_articles/by_ticket/${id}`;
  const res = await fetch(url, {
    method: "GET",
    headers: {
      "user-email": email,
      "user-type": "Customer",
      "user-org": organisationName,
    },
  });
  const data = await res.json();
  if (!res.ok) {
    Toastr.handleShow(false, "Failed to load");
  }
  return data;
}

export async function createTicket(data) {
  const { email, firstname, lastname } = getData();
  const url = `${BASEURL}api/v1/tickets`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "user-email": email,
      "user-firstname": firstname,
      "user-lastname": lastname,
      "user-type": "Customer",
      "user-org": organisationName,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    Toastr.handleShow(false, "Failed to create ticket");
  }
  return res;
}

export async function addComment(data, id) {
  const { email, firstname, lastname } = getData();
  const url = `${BASEURL}api/v1/tickets/${id}`;
  const res = await fetch(url, {
    method: "PUT",
    headers: {
      "user-email": email,
      "user-firstname": firstname,
      "user-lastname": lastname,
      "user-type": "Customer",
      "user-org": organisationName,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  return res;
}

export async function reopenTicket(id) {
  const { email, firstname, lastname } = getData();
  const url = `${BASEURL}api/v1/tickets/${id}`;
  const res = await fetch(url, {
    method: "PUT",
    headers: {
      "user-email": email,
      "user-firstname": firstname,
      "user-lastname": lastname,
      "user-type": "Customer",
      "user-org": organisationName,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      state: "open",
    }),
  });
  return res;
}

export async function getNotifications() {
  const { email, firstname, lastname } = getData();
  const url = `${BASEURL}api/v1/online_notifications`;
  const res = await fetch(url, {
    method: "GET",
    headers: {
      "user-email": email,
      "user-firstname": firstname,
      "user-lastname": lastname,
      "user-type": "Customer",
      "user-org": organisationName,
    },
  });
  const data = await res.json();
  return data;
}

export async function seenAllNotifications() {
  const { email, firstname, lastname } = getData();
  const url = `${BASEURL}api/v1/online_notifications/mark_all_as_read`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "user-email": email,
      "user-firstname": firstname,
      "user-lastname": lastname,
      "user-type": "Customer",
      "user-org": organisationName,
    },
    body: "",
  });
  const data = await res.json();
  return data;
}